import React, { useState, useCallback } from 'react';
import Guid from 'devextreme/core/guid';
import useApi from '../../hooks/useApi';

interface dataSourceDepotType {
  depot: any[],
  detailsDepot: any[]
}

interface dataSourcePlageHoraireDureeProps {
  dateCreation: number,
  dateModification: string,
  dateSuppression: string,
  idUsagerCreation: string,
  idUsagerModification: string,
  idUsagerSuppression: string,
  idPlanEntete: string,
  isDeleted: boolean,
  typePeriode: number,
  idTypeUnite?: string,
  description?: string,
  idPlageHoraireDuree?: string,
  idPlageHoraire?: string
  duree?: number,
  hebergementTaxable?: boolean,
  sejour?: false,
  annuel?: false,
  inclureCalculTauxOccupation?: boolean,
  ordreAffichage?: number,
  genererDateCommeHebergTaxab?: boolean,
  dureePeriode?: number,
  nombreColonnes?: number,
  calDateDebut?: string,
  calDateFin?: string,
  tailleColonne?: number,
  image?: string,
  actif?: boolean,
  disponibleEnLigne?: boolean
  descriptionWeb?: string,
  idTypeUniteGroupe?: string,
  descriptionAnglaise?: string,
  cacherHeures?: boolean,
  idPlanEntetePersAdd?: string,
  gererNombrePersonne?: boolean,
  descriptionWebAnglais?: string,
  afficherUnites?: boolean,
  maxUnitesReservationEnLigne?: number,
  utiliserForfaitsPourCategoriesEtUnites?: boolean,
  afficherCalendrierEnLigne?: boolean,
  afficherCarteEnLigne?: boolean,
  nomCarteEnLigne?: string,
  calDateDebutInternet?: string,
  calDateFinInternet?: string,
  maxJoursAvanceInternet?: number,
  acombaProjet?: string,
  delaiEntreDeparts?: number,
  idTermeEtCondition?: string,
  svgDescription?: string,
  svgImage?: string,
  svgData?: string,
  afficherInfoTerrain?: boolean,
  nePasDemanderTranchesAges?: boolean,
  idMessage?: string,
  idProduitOption?: string,
  nombreAnimauxMax?: number,
  idPlanEnteteAnimaux?: string,
  unePersonneParUnite?: boolean,
  periodeTampon?: number,
}

let DataSourceDepotDetails: any[] = [];

const pathName = {
  depot: "depots",
  forfait: "forfaits",
  plageHoraire: "plagesHoraires",
  periode: "periodesDureesMinimum",
  plageHoraireDuree: "plagesHorairesDurees",
}

//cette fonction permet de trier les depots et leur details
const depositProcessing = (dataArray: any[]) => {
  //filtre les parennts
  const filterDepotWithId = dataArray.filter(depot => depot?.idTypeUniteDepotParent.isEmpty());
  let dataWithdetailsDepot: dataSourceDepotType = {
    depot: [],
    detailsDepot: []
  };

  // filtre les details
  if (filterDepotWithId.length > 0) {
    filterDepotWithId.forEach((depot: any) => {
      const detailsDepot = dataArray.filter(child => child?.idTypeUniteDepotParent.equals(depot?.idTypeUniteDepot));
      dataWithdetailsDepot = {
        depot: [...dataWithdetailsDepot.depot, depot],
        detailsDepot: [...dataWithdetailsDepot.detailsDepot, ...detailsDepot]
      };
      DataSourceDepotDetails = detailsDepot
    });
  }
  return dataWithdetailsDepot;
}


//cette fonction permet de recuperer les heures et les minutes disponibles dans la reponde de API
const plageHoraireProcessing = (dataArray: any[]) => {
  const newData = dataArray.map((element) => {
    const debut = element.debut;
    const heure = Math.floor(debut.totalHours);
    const minute = debut.minutes;
    const duree = `${heure < 10 ? '0' + heure : heure}:${minute < 10 ? '0' + minute : minute}`;
    return { ...element, duree };
  });
  return newData;
}

const useLoadTypeUnite = (ITypeUnite: Guid | null | undefined) => {
  const { getData: getDataTypeUnite } = useApi<dataSourcePlageHoraireDureeProps[]>();
  const [dataForfait, setDataForfait] = useState<any[]>([]);
  const [dataPeriode, setDataPeriode] = useState<any[]>([]);
  const [dataSourceDepot, setDataSourceDepot] = useState<dataSourceDepotType>({
    depot: [],
    detailsDepot: []
  });
  const [dataSourcePlageHoraire, setDataSourcePlageHoraire] = useState<any[]>([]);
  const [dataSourcePlageHoraireDuree, setDataSourcePlageHoraireDuree] = useState<any[]>([]);

  const _loadingData = useCallback(async () => {
    if (ITypeUnite) {
      await Promise.all([
        getData(ITypeUnite, pathName.depot),
        getData(ITypeUnite, pathName.periode),
        getData(ITypeUnite, pathName.forfait),
        getData(ITypeUnite, pathName.plageHoraire),
        getData(ITypeUnite, pathName.plageHoraireDuree),
      ]);
    }
  }, [ITypeUnite])

  const getData = async (ITypeUnite: Guid, path: string) => {
    const result = await getDataTypeUnite({customPath: `typeUnite/${ITypeUnite}/${path}`});
    const resultArray = Object.values(result);

    switch (path) {
      case pathName.depot:
        setDataSourceDepot(depositProcessing(resultArray));
        break;
      case pathName.periode:
        setDataPeriode(resultArray);
        break;
      case pathName.forfait:
        setDataForfait(resultArray);
        break;
      case pathName.plageHoraire:
        setDataSourcePlageHoraire(plageHoraireProcessing(resultArray));
        break;
      case pathName.plageHoraireDuree:
        setDataSourcePlageHoraireDuree(resultArray);
        break;
      default:
        break;
    }

  }

  function getDataSourceDepotDetails() {
    _loadingData();
    return DataSourceDepotDetails;
  }

  const _getDataSourcePlageHoraireDuree = useCallback(async () => {
    const result = ITypeUnite ? await getDataTypeUnite({customPath: `typeUnite/${ITypeUnite}/${pathName.plageHoraireDuree}`}) : []
    return result
  },[ITypeUnite])

  return {
    // values
    dataPeriode,
    dataForfait,
    dataSourceDepot,
    dataSourcePlageHoraire,
    dataSourcePlageHoraireDuree,
    //methods
    _loadingDataTypeUnite: _loadingData,
    _getDataSourceDepotDetails: getDataSourceDepotDetails,
    _getDataSourcePlageHoraireDuree:_getDataSourcePlageHoraireDuree,
  };
}

export default useLoadTypeUnite

